import { ListItem, ListItemIcon, ListItemText, ListItemSecondaryAction, IconButton } from "@material-ui/core";
import Add from "@material-ui/icons/Add";
import Domain from "@material-ui/icons/Domain";

import { SelectedClient } from "@/utilities/types/search";

import { resultStyles } from "./ResultStyles";


interface ClientResultProps {
    name: string,
    index: number,
    id: number
    onSelect: (client_id: SelectedClient) => void;
}

const ClientResult = (props : ClientResultProps ) => {
    const { name, id, onSelect } = props;

    const classes = resultStyles();

    const handleOnClick = () => {
        onSelect( { id, name });
    };

    return (
        <ListItem
            key={props.index}
            data-testid={"client-result"}
            className={classes.item}
            onClick={handleOnClick}
            button
        >
            <ListItemIcon>
                <Domain color="action" />
            </ListItemIcon>
            <ListItemText primary={name}/>
            <ListItemSecondaryAction>
                <IconButton onClick={handleOnClick}><Add /></IconButton>
            </ListItemSecondaryAction>
        </ListItem>
    );
};

export default ClientResult;
